import { withFilters } from '@wordpress/components';
import { Fragment } from '@wordpress/element';
import { sprintf, __ } from '@wordpress/i18n';
import { Header } from './components/header';

/**
 * Internal dependencies
 */
import { Promo } from '../admin/settings/promo';

const Placeholder = withFilters( 'popper.settings.analytics' )( () => {
	return <Fragment></Fragment>;
} );

export const Analytics = () => {
	const promoMessage = sprintf(
		/* translators: Link to site. */
		__(
			'<p>You can add mail services integrations (Mailchimp, ConvertKit, MailPoet, GetResponse and more…) to your popups with %s.</p><p>You can also send data to Google Sheets or to webhooks and more.</p>',
			'popper'
		),
		`<a href="https://www.francescopepe.com/popper/" target="_blank">Popper Pro</a>`
	);
	return (
		<Fragment>
			<Header title={ 'Analytics' } />
			<div className="popper-content">
				<Promo message={ promoMessage } />
				<Placeholder />
			</div>
		</Fragment>
	);
};
